module.exports = __webpack_public_path__ + "img/iniciar.f510aace.png";